var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h1',[_vm._v("Area executar:")]),_c('ul',_vm._l((_vm.cursos_ead_dados),function(curso){return _c('li',{key:curso.id},[_vm._v(" "+_vm._s(curso.nome_curso)+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }